module.exports = __webpack_public_path__ + "img/feature-app-image.d502dedb.jpg";